<p class="bold-text" *ngIf="title && isStoneCreek">{{ title }}</p>
<div class="phone-wrap">
  <div class="phone" [ngClass]="{ 'phone-invalid': error.invalid && (!error.dirty || error.touched || forceTouched) }">
    <div class="phone__input">
      <div class="phone-container">
        <form action="" class="phone-form" [formGroup]="phoneGroup">
          <ngx-intl-tel-input
            [cssClass]="'phone-custom'"
            [enableAutoCountrySelect]="true"
            [enablePlaceholder]="true"
            [searchCountryFlag]="true"
            [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
            [selectFirstCountry]="false"
            [selectedCountryISO]="selectedCountry"
            [preferredCountries]="allowCountries"
            [maxLength]="15"
            [phoneValidation]="true"
            [separateDialCode]="separateDialCode"
            [numberFormat]="PhoneNumberFormat.National"
            [disabled]="isUpdating"
            customPlaceholder="Phone Number (555)555-5555"
            type="phone"
            formControlName="phone"
          >
          </ngx-intl-tel-input>
        </form>
      </div>
      <div class="btn-container">
        <button
          class="phone__input-button {{ verifyButtonTextStyle }}"
          *ngIf="showVerifyButton && !startSent && !error.invalid"
          [ngStyle]="{ cursor: enableVerifyButton ? 'pointer' : 'default' }"
          [disabled]="!enableVerifyButton"
          (click)="getVerificationCode()"
        >
          {{ verifyButtonText }}
        </button>
        <div class="phone__input-button spinner-wrapper" *ngIf="startSent">
          <app-spinner class="phone-spinner"></app-spinner>
        </div>
      </div>
    </div>
    <div class="phone__verification" *ngIf="needVerification">
      <ion-text class="phone__verification-description">Enter code to verify</ion-text>
      <div>
        <app-sms-code (enterCode)="sendVerifyingCode($event)"></app-sms-code>
      </div>
      <ion-text class="phone__verification-error" *ngIf="codeFailed">Invalid code</ion-text>
    </div>
  </div>
  <div class="required-symbol">*</div>
</div>

<p class="phone__input-error" *ngIf="error.invalid && (!error.dirty || error.touched || forceTouched)">{{ errorMessage }}</p>
